import React, { useState, useEffect, useRef } from 'react';
import {
  Play,
  Pause,
  SkipBack,
  SkipForward,
  Repeat,
  Shuffle,
  Volume2,
  VolumeX,
  Maximize2,
  Minimize2,
  List,
  Heart,
  Share2,
  Download
} from 'lucide-react';
import './App.css';

const MusicPlayer = () => {
  const [songs] = useState([
    /*
    {
      id: 1,
      title: "Éclat d'Été",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image1.jpeg",
      audio: "/audio/Éclat d_Été.mp3"
    },
    {
      id: 2,
      title: "Nuit en Cadillac",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image2.jpeg",
      audio: "/audio/Nuit en Cadillac.mp3"
    },
    {
      id: 3,
      title: "Quand la nuit devient éternelle",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image3.jpeg",
      audio: "/audio/Quand la nuit devient éternelle.mp3"
    },
    {
      id: 4,
      title: "Ombre",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image4.jpeg",
      audio: "/audio/Ombre.mp3"
    },
    {
      id: 5,
      title: "TurboNuit",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image5.jpeg",
      audio: "/audio/TurboNuit.mp3"
    },
    {
      id: 6,
      title: "Mirages de Verre",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Mirages de Verre.mp3"
    },
    {
      id: 7,
      title: "Été Dansant",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image7.jpeg",
      audio: "/audio/Été Dansant.mp3"
    },
    {
      id: 8,
      title: "Perdus dans le bruit",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image8.jpeg",
      audio: "/audio/Perdus dans le bruit.mp3"
    },
    {
      id: 9,
      title: "Electric Dance",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image9.jpg",
      audio: "/audio/Electric Dance.mp3"
    },
    {
      id: 10,
      title: "Nuit Éternelle",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image10.jpg",
      audio: "/audio/Nuit Éternelle.mp3"
    },
    {
      id: 11,
      title: "Dancing Demons",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Dancing Demons.mp3"
    },
    {
      id: 12,
      title: "La Confrontation",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/La Confrontation.mp3"
    },
    {
      id: 13,
      title: "Dernier Soleil",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Dernier Soleil.mp3"
    },
    {
      id: 14,
      title: "Le Dernier Métro",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Le Dernier Métro.mp3"
    },
    {
      id: 15,
      title: "Le Soleil Meurt (The Sun Dies)",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Le Soleil Meurt (The Sun Dies).mp3"
    },
    {
      id: 16,
      title: "Les Phares Dans La Nuit",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Les Phares Dans La Nuit.mp3"
    },*/
    {
      id: 17,
      title: "Tempête",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Tempête.mp3"
    },/*
    {
      id: 18,
      title: "Virevolte",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image6.jpeg",
      audio: "/audio/Virevolte.mp3"
    },*/
    {
      id: 19,
      title: "Doux Chaos",
      artist: "the.kr0",
      duration: "3:45",
      cover: "/image/image11.jpg",
      audio: "/audio/Doux Chaos.mp3"
    },

  ]);

  const [playlists] = useState({
    Chill: [songs[0], songs[1], songs[2], songs[3], songs[5], songs[6], songs[7], songs[12], songs[18]],
  });

  const [currentSongIndex, setCurrentSongIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isRepeat, setIsRepeat] = useState(false);
  const [isShuffle, setIsShuffle] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(80);
  const [activeTab, setActiveTab] = useState(localStorage.getItem("activeTab") || 'Chill');
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isPlaylistVisible, setIsPlaylistVisible] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [activeSongList, setActiveSongList] = useState([]);
  const [visualizerActive, setVisualizerActive] = useState(false);

  const audioRef = useRef(null);
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const sourceRef = useRef(null);

  const currentSong = songs[currentSongIndex];

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  useEffect(() => {
    const savedFavorites = JSON.parse(localStorage.getItem("favorites") || "[]");
    setFavorites(savedFavorites);
  }, []);

  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
  }, [favorites]);

  useEffect(() => {
    if (activeTab === "Liked") {
      setActiveSongList(songs.filter(song => favorites.includes(song.id)));
    } else {
      setActiveSongList(playlists[activeTab]);
    }
  }, [activeTab, playlists, favorites, songs]);

  useEffect(() => {
    if (visualizerActive && canvasRef.current && audioRef.current) {
      if (!audioContextRef.current) {
        audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
        analyserRef.current = audioContextRef.current.createAnalyser();
        analyserRef.current.fftSize = 256;
      }

      if (sourceRef.current) {
        sourceRef.current.disconnect();
      }

      sourceRef.current = audioContextRef.current.createMediaElementSource(audioRef.current);
      sourceRef.current.connect(analyserRef.current);
      analyserRef.current.connect(audioContextRef.current.destination);

      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      const bufferLength = analyserRef.current.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      const renderFrame = () => {
        animationRef.current = requestAnimationFrame(renderFrame);
        analyserRef.current.getByteFrequencyData(dataArray);

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const barWidth = (canvas.width / bufferLength) * 2.5;
        let x = 0;

        for (let i = 0; i < bufferLength; i++) {
          const barHeight = dataArray[i] / 2;
          const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
          gradient.addColorStop(0, `rgba(0, 255, 255, ${barHeight / 100})`);
          gradient.addColorStop(1, `rgba(255, 0, 255, ${barHeight / 100})`);
          ctx.fillStyle = gradient;
          ctx.fillRect(x, canvas.height - barHeight, barWidth, barHeight);
          x += barWidth + 1;
        }
      };

      renderFrame();

      return () => {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
      };
    }
  }, [visualizerActive]);

  useEffect(() => {
    if (currentSong && 'mediaSession' in navigator) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: currentSong.title,
        artist: currentSong.artist,
        album: 'Album',
        artwork: [
          {
            src: currentSong.cover,
            sizes: '512x512',
            type: 'image/jpeg'
          }
        ]
      });

      navigator.mediaSession.setActionHandler('play', () => togglePlay());
      navigator.mediaSession.setActionHandler('pause', () => togglePlay());
      navigator.mediaSession.setActionHandler('nexttrack', () => playNextSong());
      navigator.mediaSession.setActionHandler('previoustrack', () => playPrevSong());
    }
  }, [currentSongIndex, currentSong]);

  const togglePlay = () => {
    if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
      audioContextRef.current.resume();
    }
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  };

  const playNextSong = () => {
    let nextIndex;
    if (isShuffle) {
      nextIndex = Math.floor(Math.random() * songs.length);
    } else {
      nextIndex = (currentSongIndex + 1) % songs.length;
    }
    setCurrentSongIndex(nextIndex);
  };

  const playPrevSong = () => {
    let prevIndex;
    if (isShuffle) {
      prevIndex = Math.floor(Math.random() * songs.length);
    } else {
      prevIndex = (currentSongIndex - 1 + songs.length) % songs.length;
    }
    setCurrentSongIndex(prevIndex);
  };

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && audioRef.current) {
        if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
          audioContextRef.current.resume().then(() => {
            audioRef.current.play().catch(err =>
              console.log("Lecture automatique bloquée :", err)
            );
          });
        } else {
          audioRef.current.play().catch(err =>
            console.log("Lecture automatique bloquée :", err)
          );
        }
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
      audioContextRef.current.resume().catch(err =>
        console.log("Impossible de reprendre l'AudioContext :", err)
      );
    }
  }, [isPlaying]);

  useEffect(() => {
    const handleFocus = () => {
      if (isPlaying && audioRef.current.paused) {
        if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
          audioContextRef.current.resume().then(() => {
            audioRef.current.play().catch(err =>
              console.log("Lecture automatique bloquée :", err)
            );
          });
        } else {
          audioRef.current.play().catch(err =>
            console.log("Lecture automatique bloquée :", err)
          );
        }
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [isPlaying]);

  useEffect(() => {
    if (audioRef.current && currentSong) {
      audioRef.current.load();
      if (isPlaying) {
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise.catch(error => console.log("Autoplay blocked", error));
        }
      }
    }
  }, [currentSongIndex, currentSong]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = isMuted ? 0 : volume / 100;
    }
  }, [volume, isMuted]);

  const updateProgress = () => {
    if (audioRef.current) {
      setProgress((audioRef.current.currentTime / audioRef.current.duration) * 100);
      setDuration(audioRef.current.duration);
    }
  };

  const formatTime = (time) => {
    if (isNaN(time)) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const seekTo = (event) => {
    const progressBarWidth = event.target.offsetWidth;
    const clickPosition = event.clientX - event.target.getBoundingClientRect().left;
    const newProgress = (clickPosition / progressBarWidth) * 100;
    setProgress(newProgress);
    if (audioRef.current) {
      audioRef.current.currentTime = (newProgress / 100) * audioRef.current.duration;
    }
  };

  const toggleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
  };

  const togglePlaylistVisibility = () => {
    setIsPlaylistVisible(!isPlaylistVisible);
  };

  const toggleFavorite = (songId) => {
    if (favorites.includes(songId)) {
      const newFavorites = favorites.filter(id => id !== songId);
      console.log("Retrait des favoris :", newFavorites);
      setFavorites(newFavorites);
    } else {
      const newFavorites = [...favorites, songId];
      console.log("Ajout aux favoris :", newFavorites);
      setFavorites(newFavorites);
    }
  };

  const toggleVisualizer = () => {
    setVisualizerActive(!visualizerActive);
    if (!visualizerActive && audioContextRef.current && audioContextRef.current.state === 'suspended') {
      audioContextRef.current.resume();
    }
  };

  return (
    <div className={`music-player-container ${isFullScreen ? 'fullscreen' : ''}`}>
      <div className="futuristic-background"></div>

      <div className="main-content">
        <audio
          ref={audioRef}
          onTimeUpdate={updateProgress}
          onEnded={playNextSong}
          loop={isRepeat}
          muted={isMuted}
        >
          {currentSong?.audio && <source src={currentSong.audio} type="audio/mpeg" />}
          Your browser does not support the audio element.
        </audio>
        {visualizerActive && (
          <div className="visualizer-container">
            <canvas ref={canvasRef} className="audio-visualizer"></canvas>
          </div>
        )}

        <div className="music-player-header">
          <div className="album-cover-container">
            <div className={`album-cover ${isPlaying ? 'rotating' : ''}`}>
              {currentSong?.cover && <img src={currentSong.cover} alt={`${currentSong?.title} cover`} />}
              <div className="cover-overlay">
                <h4>{currentSong?.title}</h4>
                <p>{currentSong?.artist}</p>
              </div>
            </div>
            <div className="album-actions">
              <button
                className={`favorite-btn ${favorites.includes(currentSong?.id) ? 'active' : ''}`}
                onClick={() => toggleFavorite(currentSong?.id)}
                aria-label="Add to favorites"
              >
                <Heart size={18} />
              </button>
              <button aria-label="Share">
                <Share2 size={18} />
              </button>
              <button aria-label="Download">
                <Download size={18} />
              </button>
            </div>
          </div>

          <div className="music-player-info">
            <div className="song-info">
              <h2>{currentSong?.title}</h2>
              <p>{currentSong?.artist}</p>
            </div>

            <div className="progress-container">
              <div className="progress-bar" onClick={seekTo}>
                <div className="progress-bar-track">
                  <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
                  <div className="progress-handle" style={{ left: `${progress}%` }}></div>
                </div>
                <div className="time-info">
                  <span>{formatTime(audioRef.current?.currentTime || 0)}</span>
                  <span>{formatTime(duration)}</span>
                </div>
              </div>
            </div>

            <div className="controls-container">
              <div className="controls primary-controls">
                <button
                  onClick={() => setIsShuffle(!isShuffle)}
                  className={isShuffle ? 'active' : ''}
                  aria-label="Shuffle"
                >
                  <Shuffle size={20} />
                </button>
                <button onClick={playPrevSong} aria-label="Previous song">
                  <SkipBack size={24} />
                </button>
                <button
                  onClick={togglePlay}
                  className="play-pause-btn"
                  aria-label={isPlaying ? "Pause" : "Play"}
                >
                  {isPlaying ? <Pause size={28} /> : <Play size={28} />}
                </button>
                <button onClick={playNextSong} aria-label="Next song">
                  <SkipForward size={24} />
                </button>
                <button
                  onClick={() => setIsRepeat(!isRepeat)}
                  className={isRepeat ? 'active' : ''}
                  aria-label="Repeat"
                >
                  <Repeat size={20} />
                </button>
              </div>

              <div className="controls secondary-controls">
                <button onClick={togglePlaylistVisibility} aria-label="Show playlist">
                  <List size={20} />
                </button>
                <button onClick={toggleFullScreen} aria-label="Toggle fullscreen">
                  {isFullScreen ? <Minimize2 size={20} /> : <Maximize2 size={20} />}
                </button>
              </div>
            </div>

            <div className="volume-controls">
              <button onClick={() => setIsMuted(!isMuted)} aria-label={isMuted ? "Unmute" : "Mute"}>
                {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
              </button>
              <input
                type="range"
                min="0"
                max="100"
                value={volume}
                onChange={(e) => setVolume(e.target.value)}
                className="volume-slider"
                aria-label="Volume"
              />
            </div>
          </div>
        </div>

        <div className="tabs">
          {["Liked", ...Object.keys(playlists)].map((playlistName) => (
            <button
              key={playlistName}
              className={`tab-button ${activeTab === playlistName ? 'active' : ''}`}
              onClick={() => setActiveTab(playlistName)}
            >
              {playlistName}
            </button>
          ))}
        </div>

        {isPlaylistVisible && (
          <div className={`playlist-container ${isFullScreen ? 'fullscreen' : ''}`}>
            <div className="playlist-header">
              <h3>{activeTab} Playlist</h3>
              <p>{activeSongList.length} tracks</p>
            </div>
            <div className="playlist">
              {activeSongList.map((song) => (
                song && song.cover ? (
                  <div
                    key={song.id}
                    className={`playlist-item ${songs.indexOf(song) === currentSongIndex ? 'active' : ''}`}
                    onClick={() => {
                      setCurrentSongIndex(songs.indexOf(song));
                      setIsPlaying(true);
                      setTimeout(() => audioRef.current.play(), 0);
                    }}
                  >
                    <div className="playlist-item-cover">
                      <img src={song.cover} alt={song.title} />
                      {songs.indexOf(song) === currentSongIndex && isPlaying && (
                        <div className="now-playing-indicator">
                          <div className="bar"></div>
                          <div className="bar"></div>
                          <div className="bar"></div>
                        </div>
                      )}
                    </div>
                    <div className="playlist-item-info">
                      <h4>{song.title}</h4>
                      <p>{song.artist}</p>
                    </div>
                    <div className="playlist-item-actions">
                      <span className="duration">{song.duration}</span>
                      <button
                        className={`favorite-btn ${favorites.includes(song.id) ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleFavorite(song.id);
                        }}
                        aria-label="Add to favorites"
                      >
                        <Heart size={16} />
                      </button>
                    </div>
                  </div>
                ) : null
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MusicPlayer;